<template>
    <div class="survey_banner_area" :style="propStyle" v-if="isShowSurvey">
        <img 
            id="banner_image"
            class="banner_image" 
            v-bind:src="banner_image_url"
            v-on:click="onSurvey"
        />
    </div>
</template>

<script>
    import { mapState } from "vuex"
    export default {
        props: {
            propStyle: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                isClickBanner: false
            }
        },
        async mounted() {
            await this.$store.dispatch('survey/getSurvey')
            this.checkErrorBannerImage()
        },
        computed: {
        ...mapState({
            survey_id: state => state.survey.survey_id,
            banner_redirect_url: state => state.survey.banner_redirect_url,
            survey_thank_page_url: state => state.survey.survey_thank_page_url,
            banner_image_url: state => state.survey.banner_image_url,
            survey_start_date: state => state.survey.survey_start_date,
            survey_end_date: state => state.survey.survey_end_date,
        }),
        isShowSurvey() {
            if (this.$store.state.auth.doctorInfo.id !== undefined){
                if(this.banner_image_url) {
                    this.$emit("isShowBanner", true)
                    return true
                }
                else {
                    this.$emit("isShowBanner", false)
                    return false
                }
            }
        }
    },
        methods: {
            checkErrorBannerImage: function () {
                let image_banner = document.getElementById("banner_image");
                if (image_banner) {
                    this.banner_image_url ? image_banner.src = this.banner_image_url : null;
                    image_banner.onerror = function () {
                        alert(this.$t('image_loading_error'));
                        this.src = "https://businessbeyondlimits.com/wp-content/uploads/2015/02/400x100.gif";
                    };
                }
            },
            onSurvey () {
                let url = ""
                if(!this.isClickBanner && this.banner_redirect_url) {
                    url = this.getBannerRediectUrl()
                } else {
                    const surveyComplete = JSON.parse(localStorage.getItem("vuex")).survey.surveyComplete
                    if (surveyComplete) {
                        url = this.survey_thank_page_url
                    } else {
                        url = this.getBannerRediectUrl()
                    }
                }
                this.isClickBanner = true
                this.bannerTracking(url)
                window.open(url, '_blank')
            },
            getBannerRediectUrl() {
                let user_id = this.$store.state.auth.doctorInfo.id
                return this.survey_id ? this.banner_redirect_url + (this.banner_redirect_url.slice(-1) === '/' ? "1?data="+user_id : "/1?data="+user_id) : this.banner_redirect_url
            }
        },
    }
</script>
<style scoped>
    .survey_banner_area{
        width: 100%;
        height: auto;
        margin: 15px 0 15px 0;
        display: flex;
        justify-content: center ;
    }
    .banner_image{
        width: 400px;
        height: 100px;
    }
    .banner_image:hover {
        border: 1px solid #ff9fae;
        cursor: pointer;
    }
</style>